import React from 'react'
import { FiPlusCircle } from 'react-icons/fi'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { friendList } from './mock';

export const Friendship = () => {
    const [tabIndex, setTabIndex] = React.useState(0);

    return (
       <div className="friendship-component">

            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)} >
                <TabList className="tabs">
                    <Tab className="tab">Friends <p>(585)</p></Tab>
                    <Tab className="tab">Posts <p>(120)</p></Tab>
                    <Tab className="tab">Requests</Tab>
                    <Tab className="tab">Projects </Tab>
                </TabList>

                <TabPanel className="panel">
                    <div>
                        <ul className="friend-list">
                            {
                                friendList.map((item,i)=>(
                                    <li key={'friend_list'+i} >
                                        <div className="flex-start">
                                            {item.avatar && <img src={`/assets/images/faces/${item.avatar}.png`} alt={item.avatar} />}
                                            {!item.avatar && <img src="/assets/images/faces/default.svg" alt="default" />  }
                                            <div>
                                                <h4 className="name">{item.name}</h4>
                                                <p>{item.description}</p>
                                            </div>
                                        </div>
                                        <div className="icon">
                                            <FiPlusCircle />
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </TabPanel>
                <TabPanel className="panel"></TabPanel>
            </Tabs>
       </div>
    )
}